/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The category of the room.
 */
export const RoomCategoryDTO = {
    BEAUTY_BODY: 'BEAUTY_BODY',
    HAIR: 'HAIR',
    FITNESS: 'FITNESS',
    EVENT: 'EVENT',
    WORKSHOP: 'WORKSHOP',
    WELLNESS_SERVICE: 'WELLNESS_SERVICE'
} as const;
export type RoomCategoryDTO = typeof RoomCategoryDTO[keyof typeof RoomCategoryDTO];

